// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.position-relative {
  position: relative;
}

/* input */
.time-input {
  padding-right: 2.5rem;
  cursor: pointer;
}

/* botón clear */
.btn-clear-time {
  position: absolute;
  top: 50%;
  right: 0.5rem;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6c757d;
}

.btn-clear-time:hover {
  color: #dc3545;
}

/* icono */
.btn-clear-time mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInRpbWUtaW5wdXQtdjMuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsZ0JBQWdCO0FBQWhCO0VBQ0Usa0JBQUE7QUFFRjs7QUFDQSxVQUFBO0FBQ0E7RUFDRSxxQkFBQTtFQUNBLGVBQUE7QUFFRjs7QUFDQSxnQkFBQTtBQUNBO0VBQ0Usa0JBQUE7RUFDQSxRQUFBO0VBQ0EsYUFBQTtFQUNBLDJCQUFBO0VBQ0EsWUFBQTtFQUNBLHVCQUFBO0VBQ0EsVUFBQTtFQUNBLGVBQUE7RUFDQSxhQUFBO0VBQ0EsbUJBQUE7RUFDQSx1QkFBQTtFQUNBLGNBQUE7QUFFRjs7QUFDQTtFQUNFLGNBQUE7QUFFRjs7QUFDQSxVQUFBO0FBQ0E7RUFDRSxlQUFBO0VBQ0EsV0FBQTtFQUNBLFlBQUE7QUFFRiIsImZpbGUiOiJ0aW1lLWlucHV0LXYzLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnBvc2l0aW9uLXJlbGF0aXZlIHtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xufVxuXG4vKiBpbnB1dCAqL1xuLnRpbWUtaW5wdXQge1xuICBwYWRkaW5nLXJpZ2h0OiAyLjVyZW07IC8vIGVzcGFjaW8gcGFyYSBsYSBYXG4gIGN1cnNvcjogcG9pbnRlcjtcbn1cblxuLyogYm90w7NuIGNsZWFyICovXG4uYnRuLWNsZWFyLXRpbWUge1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHRvcDogNTAlO1xuICByaWdodDogMC41cmVtO1xuICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoLTUwJSk7XG4gIGJvcmRlcjogbm9uZTtcbiAgYmFja2dyb3VuZDogdHJhbnNwYXJlbnQ7XG4gIHBhZGRpbmc6IDA7XG4gIGN1cnNvcjogcG9pbnRlcjtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIGNvbG9yOiAjNmM3NTdkO1xufVxuXG4uYnRuLWNsZWFyLXRpbWU6aG92ZXIge1xuICBjb2xvcjogI2RjMzU0NTtcbn1cblxuLyogaWNvbm8gKi9cbi5idG4tY2xlYXItdGltZSBtYXQtaWNvbiB7XG4gIGZvbnQtc2l6ZTogMThweDtcbiAgd2lkdGg6IDE4cHg7XG4gIGhlaWdodDogMThweDtcbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/shared/components/time-input-v3/time-input-v3.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,kBAAA;AAEF;;AACA,UAAA;AACA;EACE,qBAAA;EACA,eAAA;AAEF;;AACA,gBAAA;AACA;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,2BAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA,UAAA;AACA;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAEF;AACA,o5CAAo5C","sourcesContent":[".position-relative {\n  position: relative;\n}\n\n/* input */\n.time-input {\n  padding-right: 2.5rem; // espacio para la X\n  cursor: pointer;\n}\n\n/* botón clear */\n.btn-clear-time {\n  position: absolute;\n  top: 50%;\n  right: 0.5rem;\n  transform: translateY(-50%);\n  border: none;\n  background: transparent;\n  padding: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #6c757d;\n}\n\n.btn-clear-time:hover {\n  color: #dc3545;\n}\n\n/* icono */\n.btn-clear-time mat-icon {\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
